import { InternalAxiosRequestConfig } from 'axios'

export const onFulfilled = async (request: InternalAxiosRequestConfig<any>) => {
  request.headers.set('X-LocalTimeZone', Intl.DateTimeFormat().resolvedOptions().timeZone)

  return request
}
